<div class="flex items-center gap-4">
  @if (ghostInProgress()) {
    <span i18n>In progress. Page will reload soon.</span>
  } @else if (ghostedName()) {
    <span>👻 {{ ghostedName() }}</span>
    <button class="underline text-sm" (click)="stop()" i18n>Stop</button>
  } @else if (canGhost()) {
    <button
      (click)="wantsToGhost.set(!wantsToGhost())"
      [class.opacity-30]="!wantsToGhost()"
    >
      👻
    </button>
    @if (wantsToGhost()) {
      <div>
        <app-autocomplete-customer
          class="absolute -translate-y-1/2"
          [formControl]="ghostControl"
        ></app-autocomplete-customer>
      </div>
    }
  }
</div>
